











































import Vue from 'vue';
import key from '@/libs/filters/key';
import layout from '@/libs/layout/school/return'
import { Component, Prop } from 'vue-property-decorator';
import { TReturnPage } from '@/types/views/school';
import { cancelRebackCoursePackage } from '@/api/school';
import { TLayout } from '@/types/utils';
@Component({})
export default class List extends Vue {
  @Prop({
    type: Object,
    default() {
      return {
        totalPage: 0,
        currentPage: 1,
        pageSize: 20,
        list: []
      };
    }
  })
  page!: TReturnPage;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  handleOptions!: Function;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getData!: Function;
  private layout: TLayout = layout
  private key: any = key;
  private activeId = '';

  private indexMethod(idx: number) {
    const { currentPage, pageSize } = this.page;
    return ((currentPage as number) - 1) * (pageSize as number) + idx + 1;
  }

  private handlePage(page: number) {
    this.handleOptions({ currentPage: page });
    this.getData();
  }
  private handleSize(size: number) {
    this.handleOptions({ size });
    this.getData();
  }
  withdrawApplication(id: number) {
    let opts = {
      rebackId: id
    };
    this.$confirm('确定撤销课程包返回申请吗？', '撤销返回申请')
      .then(async () => {
        try {
          await cancelRebackCoursePackage(opts);
          this.getData();
          this.$message.success('申请撤销成功。');
        } catch (err) {
          this.$message.error(err.message);
        }
      })
      .catch(() => {});
  }
}
